import * as React from 'react';
import { memo } from 'react';

const SvgAlertCircle = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12 8v4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("circle", { cx: 12, cy: 16, r: 1, fill: "currentColor" })));
const Memo = memo(SvgAlertCircle);

export { Memo as default };
